import { ENodeVehicle } from '@vae/server/src/interfaces/eNode/eNodeVehicle.interface'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../components/actions/Button'
import { SmartChargeController } from '../../../pages/devices/electricCar/smartCharging/SmartChargeController'
import EnodeInitHeader from '../components/ENodeInitHeader'

interface Props {
	goForward: () => void
	vehicles: ENodeVehicle[]
}

const SmartChargingTimeLimit: React.FC<Props> = ({ goForward, vehicles }) => {
	const { t } = useTranslation('pages_enodeInit')

	return (
		<>
			<div className='flex flex-row gap-4'>
				<EnodeInitHeader position={4} total={5} text={t('smartChargingTimeLimit.otsikko')} />
				<div className='h-[38px] flex items-center mb-2'>
					<span className='text-xl tracking-wide font-semibold dark:text-brand-secondary-100-dark'>
						{t('smartChargingTimeLimit.otsikko')}
					</span>
				</div>
			</div>

			<p className='dark:text-white'>{t('smartChargingTimeLimit.info1')}</p>

			<div className='time-set-container flex flex-row gap-4 items-center dark:text-white'>
				{t('smartChargingTimeLimit.alykasLataus')} <SmartChargeController vehicles={vehicles} />
				{t('smartChargingTimeLimit.mennessä')}
			</div>
			<div className='subtext dark:text-white'>{t('smartChargingTimeLimit.info2')}</div>

			<Button onClick={goForward}>{t('seuraava', { ns: 'common' })}</Button>
		</>
	)
}

export default SmartChargingTimeLimit
